import { connect } from '@ardoq/rxbeach';
import { emptyView$ } from 'views/streams/emptyView$';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';
import { NoNumericFieldsDoq } from 'tabview/graphViews/emptyStates/NoNumericFieldsDoq';
import { DoqType } from '@ardoq/doq';
import { NoSelectedFields, NotEnoughComponentsDoq } from './NoDataDoqys';
import { Notifier } from '@ardoq/dropdown-menu';
import { noop } from 'lodash';
import { type I18nLocale, t } from '@ardoq/i18n';

type EmptyStateProps = {
  isWorkspaceEmpty: boolean;
  hasActiveFilter: boolean;
  allDescendantsIncluded: boolean;
  noNumberFields: boolean;
  notEnoughComponents: boolean;
  noSelectedFields: boolean;
  isPresentationMode: boolean;
  openSelectFieldsViewSetting: Notifier;
  i18nLocale: I18nLocale;
};

const EmptyStateBase = ({
  isWorkspaceEmpty,
  hasActiveFilter,
  allDescendantsIncluded,
  noNumberFields,
  notEnoughComponents,
  noSelectedFields,
  isPresentationMode,
  openSelectFieldsViewSetting,
  i18nLocale,
}: EmptyStateProps) => {
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.SPIDER_CHART}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (noNumberFields) {
    return <NoNumericFieldsDoq doqType={DoqType.SPIDER_CHART} />;
  }

  if (noSelectedFields) {
    return (
      <NoSelectedFields
        onButtonClick={
          isPresentationMode ? noop : () => openSelectFieldsViewSetting.notify()
        }
        buttonLabel={
          isPresentationMode
            ? undefined
            : t(
                i18nLocale,
                'tabview:spiderChart.emptyState.selectFields',
                'Select fields'
              )
        }
        i18nLocale={i18nLocale}
      />
    );
  }

  if (hasActiveFilter || !allDescendantsIncluded) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.SPIDER_CHART}
        canApplyIncludeAllDescendantsFilter
        includeActions={false}
      />
    );
  }

  if (notEnoughComponents) {
    return <NotEnoughComponentsDoq i18nLocale={i18nLocale} />;
  }

  return null;
};

export const EmptyState = connect(EmptyStateBase, emptyView$);
